/**
 * Whether the desk operator moved on while a row print ran, so the search box must not be taken
 * back: selecting it then would let their next key wipe what they did.
 *
 * Typing in the search, or standing in another field or in a window, is moving on. A mere click
 * into the search is not; its leftover must still be selected for the next reader scan.
 */
export function operatorMovedOn(
  active: Element | null,
  search: HTMLInputElement | null,
  searchBefore: string | undefined
): boolean {
  if (search !== null && active === search) return search.value !== searchBefore;
  return (
    active instanceof HTMLElement &&
    (active.isContentEditable || active.closest('input, textarea, [role="dialog"]') !== null)
  );
}
